// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* body { */
  /* margin: 0; */
  /* font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', */
    /* 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', */
    /* sans-serif; */
  /* -webkit-font-smoothing: antialiased; */
  /* -moz-osx-font-smoothing: grayscale; */
/* } */

/* code { */
  /* font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', */
    /* monospace; */
/* } */
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,WAAW;EACT,eAAe;EACf,oFAAoF;IAClF,wEAAwE;IACxE,gBAAgB;EAClB,yCAAyC;EACzC,wCAAwC;AAC1C,MAAM;;AAEN,WAAW;EACT,0EAA0E;IACxE,eAAe;AACnB,MAAM","sourcesContent":["/* body { */\r\n  /* margin: 0; */\r\n  /* font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', */\r\n    /* 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', */\r\n    /* sans-serif; */\r\n  /* -webkit-font-smoothing: antialiased; */\r\n  /* -moz-osx-font-smoothing: grayscale; */\r\n/* } */\r\n\r\n/* code { */\r\n  /* font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', */\r\n    /* monospace; */\r\n/* } */\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
